import React, { createElement, forwardRef } from "react";
import { sanitizeHTML } from "@tootools/dom";

interface SafeHTMLProps {
  html: HTMLElement | string;
  as?: React.ElementType;
  options?: { ALLOWED_TAGS: string[]; ALLOWED_ATTR: string[] };
  [prop: string]: any;
}

const SafeHTML = forwardRef(
  (
    { as = "div", html, options, ...props }: SafeHTMLProps,
    ref: React.Ref<HTMLDivElement>
  ) =>
    createElement(
      as,
      { ...props, ref },
      <div dangerouslySetInnerHTML={sanitizeHTML(html, options)} />
    )
);

export default SafeHTML;
